/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-param-reassign */
import { createReducer, createAction } from '@reduxjs/toolkit';
import { Doctor } from '@/types';

export interface ConsultationState {
  patient_phone_number?: string;
  patient_name?: string;
  patient_id?: number;
  consultation_time?: string[]; // ['08:00', '09:00', '10:00', '12:00']
  consultation_date?: string; // 'YYYY-MM-DD'
  is_with_appointment?: boolean;
  notes?: string;
  doctor?: Doctor;
}
export type KeyOfConsultation = keyof ConsultationState;

export const initialState: ConsultationState = {
  patient_phone_number: undefined,
  patient_name: undefined,
  patient_id: undefined,
  consultation_time: [],
  consultation_date: undefined,
  is_with_appointment: false,
  notes: '',
  doctor: undefined,
};

const STORE_CONSULTATION = 'STORE_CONSULTATION';

export const storeConsultation = createAction(
  STORE_CONSULTATION,
  (payload: ConsultationState) => ({
    payload,
  })
);

export const getConsultationData: (state: any) => ConsultationState = (
  state: any
) => state;

export default createReducer(initialState, {
  [STORE_CONSULTATION]: (state, action) => {
    const newState = {
      ...state,
      ...action.payload,
    };
    return newState;
  },
});
